import { render, staticRenderFns } from "./QuotationProposalAgricolaCoverage.vue?vue&type=template&id=0e74ad94"
import script from "./QuotationProposalAgricolaCoverage.vue?vue&type=script&lang=js"
export * from "./QuotationProposalAgricolaCoverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports